import {Injectable} from '@angular/core';

/** A regional sales contact, shown wherever we surface "your representative". */
export interface SalesHead {
    region_id: number[];
    region: string;
    name: string;
    email: string;
    contact: string;
}

/**
 * Resolves which sales head a customer belongs to, from the `customer_regions`
 * id on the stored user. Shared so the site footer and the exclusive dashboard
 * footer can't drift apart on either the contact list or the matching rule.
 */
@Injectable({providedIn: 'root'})
export class SalesContactService {

    readonly salesHeads: SalesHead[] = [
        {
            region_id: [1],
            region: 'North Region',
            name: 'Rajesh Chaudhary',
            email: 'rajesh@indiapicture.in',
            contact: '9871954443'
        },
        {
            region_id: [2],
            region: 'West Region',
            name: 'Rahul Baisoya',
            email: 'rahul@indiapicture.in',
            contact: '9911082058'
        },
        {
            region_id: [3, 4],
            region: 'South & East Region',
            name: 'gaurav swami',
            email: 'teamsouth@indiapicture.in',
            contact: '9910075279'
        },
        {
            region_id: [12, 13, 19, 20, 21, 22, 23, 24],
            region: 'Online Region',
            name: 'Rahul Jaiswal',
            email: 'care@indiapicture.in',
            contact: '9599801596'
        }
    ];

    /**
     * Sales head for the signed-in customer, or null for guests and for regions
     * with no entry — callers then show their own default contact.
     */
    contactForCurrentUser(): SalesHead | null {
        const regionIds = this.currentUserRegionIds();
        if (!regionIds.length) { return null; }

        return this.salesHeads.find(s => s.region_id.some(id => regionIds.includes(id))) || null;
    }

    /**
     * Region ids from the stored user. `customer_regions` holds a single id as a
     * string in practice (e.g. "13"); a comma-separated list or an array is also
     * accepted so a multi-region account doesn't fall back to the default.
     */
    private currentUserRegionIds(): number[] {
        let raw: any = null;
        try {
            raw = JSON.parse(localStorage.getItem('currentUser') || 'null')?.customer_regions;
        } catch {
            return [];
        }

        if (raw === null || raw === undefined || raw === '') { return []; }

        return (Array.isArray(raw) ? raw : String(raw).split(','))
            .map(v => Number(String(v).trim()))
            .filter(v => !isNaN(v));
    }
}
